import AssignmentListContainer from './AssignmentListContainer';

export default AssignmentListContainer;
